<template>
  <el-row
    class="main-container">
    <el-col
      :sm="6"
      :lg="5"
      :xl="4"
      class="task-main-list">
      <div class="main-list">
        <div class="header">
          <h3>Tareas</h3>
          <el-button
            type="primary"
            circle
            class="btn-add"
            style="padding: 7px"
            @click="newTasks">
            <i class="icon-plus"/>
          </el-button>
        </div>
        <div class="body-list">
          <div
            :class="{ 'active': $route.name === 'tasks' }"
            class="item"
            @click="$router.push({ name: 'tasks' })">
            <i class="icon-check-square"/>
            <span>
              Todas las tareas
            </span>
          </div>
          <div
            :class="{ 'active': $route.name === 'today-tasks' }"
            class="item"
            @click="$router.push({ name: 'today-tasks' })">
            <i class="icon-sunrise"/>
            <span>
              Mi día
            </span>
          </div>
        </div>
      </div>
    </el-col>
    <el-col
      :sm="16"
      :lg="19"
      :xl="18"
      class="container-section-main">
      <div>
        <tasks-list
          :tasks="taskItems"
          :pager="pager"
          @currentTaskValue="getValueTaskCurrent"
          @onEditTask="editTask"/>
      </div>
    </el-col>
    <tasks-create-view
      v-if="showTaskPanel"
      :is-edit="isEdit"
      :old="oldTask"/>
    <tasks-preview
      v-if="showPrevTaskPanel"
      :current-task="taskItem"/>
  </el-row>
</template>

<script>
import TasksList from '@/modules/tasks/tasks-list'
import TasksCreateView from '@/views/app/tasks/tasks-create-view'
import TasksPreview from '@/views/app/tasks/tasks-preview'
import TasksGuards from '@/guards/tasks.guards'
export default {
  name: 'TasksView',
  components: {
    TasksList,
    TasksCreateView,
    TasksPreview
  },
  data () {
    return {
      taskItem: null,
      oldTask: null,
      isEdit: false
    }
  },
  computed: {
    taskItems () {
      return this.$store.getters['tasks/items']
    },
    pager () {
      return this.$store.getters['tasks/pagination']
    },
    showTaskPanel () {
      return this.$store.getters['app/showTaskPanel']
    },
    showPrevTaskPanel () {
      return this.$store.getters['app/showPrevTaskPanel']
    }
  },
  methods: {
    newTasks () {
      this.$store.dispatch('app/toggleTasksPanel')
      this.isEdit = false
    },
    getValueTaskCurrent (val) {
      this.taskItem = val
    },
    editTask (task) {
      this.oldTask = task
      this.isEdit = true
    }
  },
  beforeRouteUpdate: TasksGuards.onEnter
}
</script>

<style lang="scss" scoped>
  .main-container{
    height: 100%;
    width: 100%;
    overflow: hidden;
    .task-main-list {
      height: calc(100% - 60px);
      border-right: 1px solid $border-primary;
      position: relative;
      overflow: auto;
      background-color: #ffffff;
      .main-list {
        height: calc(100% - 60px);
        .header {
          display: flex;
          flex-flow: row nowrap;
          align-items: center;
          justify-content: space-between;
          padding: 15px 15px 0;
          margin-bottom: 15px;
          h3 {
            color: #707070;
            @include font-primary(21px, regular);
            margin: 0;
          }
          .btn-add {
            box-shadow: 0 3px 6px rgba(#E7120E, 0.26);
            i {
              font-size: 23px;
            }
          }
        }
        .body-list {
          .item {
            padding: 18px 15px;
            display: flex;
            flex-flow: row nowrap;
            align-items: center;
            cursor: pointer;
            margin-bottom: 10px;
            &:hover {
              background-color: #e8e6e6;
            }
            &.active {
              background-color: #e8e6e6;
            }
            i {
              color: #9D9D9D;
              font-size: 18px;
              margin-right: 15px;
            }
            span {
              font-family: Lato;
              color: #3E3E3E;
              font-size: 13px;
              font-weight: 700;
            }
          }
        }
      }
    }
    .container-section-main {
      height: calc(100% - 60px);
      background-color: $secondary;
      position: relative;
      overflow: auto;
      padding: 30px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/app/tasks/tasks-view.vue